/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { confirm } from 'components/atoms/modal';
import { Popconfirm } from 'components/atoms/popconfirm';
import { useTranslation } from 'hooks/use-translation';
import { queueMacrotask } from 'utils/macrotask';

interface Props {
  titleNode?: ReactNode;
  contentNode?: ReactNode;
  handleConfirmDelete(
    e?: React.MouseEvent<HTMLElement, MouseEvent> | undefined,
  ): void;
  handleDeleteConfirmationVisible(visibility: boolean): void;
  handleMoreActionsMenuVisibleChange: (visibility: boolean) => void;
  isDeleteConfirmationVisible: boolean;
  showModalAlert?: boolean;
}

export const DeleteConfirmationPopup: FC<Props> = ({
  handleConfirmDelete,
  handleDeleteConfirmationVisible,
  handleMoreActionsMenuVisibleChange,
  titleNode,
  contentNode,
  isDeleteConfirmationVisible,
  showModalAlert,
}) => {
  const translatedDeleteConfirmationMessageText = useTranslation(
    'delete_confirmation_message',
  );
  const translatedYesText = useTranslation('delete');
  const translatedNoText = useTranslation('cancel');
  const confirmAction = () => {
    queueMacrotask(() => {
      handleMoreActionsMenuVisibleChange(false);
    });

    return confirm({
      title: titleNode || translatedDeleteConfirmationMessageText,
      content: contentNode || translatedDeleteConfirmationMessageText,
      okText: translatedYesText,
      okType: 'danger',
      cancelText: translatedNoText,
      onOk: handleConfirmDelete,
      width: 480,
    });
  };

  return showModalAlert ? (
    <div onClick={confirmAction}>
      <FormattedMessage id="delete" />
    </div>
  ) : (
    <Popconfirm
      visible={isDeleteConfirmationVisible}
      onVisibleChange={handleDeleteConfirmationVisible}
      onConfirm={handleConfirmDelete}
      onCancel={() => handleDeleteConfirmationVisible(false)}
    >
      <div>
        <FormattedMessage id="delete" />
      </div>
    </Popconfirm>
  );
};
